import { Label } from '@cian/ui-kit';
import { IconActionChevronRightSmall16, IconFinanceSale16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './NewbuildingPurchaseGiftHeaderLabel.css';

export interface INewbuildingPurchaseGiftHeaderLabelProps {
  text: string;
  onClick(): void;
}

/**
 * Лейбл акции «30 000 ₽ за покупку квартиры» в плавающей шапке карточки ЖК.
 * Синяя пилюля с оранжевой «стопкой» справа по макету, по клику открывает модалку акции.
 * Реф на корень нужен ActionAfterViewObserver без обёртки.
 */
export const NewbuildingPurchaseGiftHeaderLabel = React.forwardRef<
  HTMLSpanElement,
  INewbuildingPurchaseGiftHeaderLabelProps
>(({ text, onClick }, ref) => {
  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLElement>) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick();
      }
    },
    [onClick],
  );

  return (
    <span ref={ref} className={styles['container']}>
      <Label
        className={styles['label']}
        background="var(--purchase-gift-brand-blue)"
        color="text-inverted-default"
        icon={<IconFinanceSale16 color="icon-inverted-default" />}
        rightIcon={<IconActionChevronRightSmall16 color="icon-inverted-default" />}
        role="button"
        tabIndex={0}
        data-testid="NewbuildingPurchaseGiftHeaderLabel"
        onClick={onClick}
        onKeyDown={handleKeyDown}
      >
        {text}
      </Label>
    </span>
  );
});

NewbuildingPurchaseGiftHeaderLabel.displayName = 'NewbuildingPurchaseGiftHeaderLabel';
